const useGetPilgrim = (pilgrimData) => {
  const {
    id,
    deposits,
    deposit_total: depositTotal,
    cart_total: cartTotal,
    deposit_transferred: depositTransferred,
    next_steps: nextSteps,
    agency_name: agencyName,
    note,
    pilgrim,
    customization,
    health,
    category_id: categoryId,
    category_name: categoryName,
    is_visa_submission: isVisaSubmission,
    self_registered: selfRegistered,
    status,
    group_id: groupId,
    group_name: groupName,
    old_pilgrim_agency_ifu: oldAgencyIfu,
  } = pilgrimData || {};

  const {
    first_name: firstname,
    last_name: lastname,
    npi,
    nic,
    is_npi_valid: isNpiValid,
    passport,
    passport_expiration: passportExpirationDate,
    is_passport_valid: isPassportValid,
    birthdate,
    is_international: isInternational,
    department,
  } = pilgrim || {};

  const {
    is_healthy: isHealthy,
    doctor_name: doctorName,
    doctor_email: doctorEmail,
    notes: doctorNotes,
  } = health || {};

  const {
    name: customizationName,
    approved: customizationApproved,
    description: customizationDescription,
    price: customizationPrice,
  } = customization || {};

  // A pilgrim is approved for the MS step if they are marked as healthy (isHealthy === true)
  const isApprovedForMSStep = isHealthy;
  // A pilgrim is rejected for the MS step if not approved (isApprovedForMSStep === false)
  const isRejectedForMSStep = !isApprovedForMSStep;
  // A pilgrim is approved for the MAEC step if their visa have been submitted (isVisaSubmission === true)
  const isApprovedForMAECStep = isVisaSubmission;
  // Checks if the pilgrim has fully paid their invoice
  const isInvoiceFullyPaid = depositTransferred >= cartTotal;
  // Checks if the pilgrim has completed the medical checkup
  const hasCompletedMedicalCheckup = isHealthy !== null;
  // Checks if the pilgrim has a passport
  const hasPassport = passport !== null;
  // A pilgrim is elligible (can make visa demand) if they have a passport, passed the MS step, and paid the full invoice
  // Alternatively, if the pilgrim is international (diaspora), has a passport, and has paid the full invoice, they are also ready for the MAEC step.
  const isElligible =
    (hasPassport && isInternational && isInvoiceFullyPaid) ||
    (hasPassport && !isInternational && isInvoiceFullyPaid && isApprovedForMSStep);
  // A newly created pilgrim is considered ready for the MS step by default so we can set this to true
  // const isReadyForMSStep = true;

  const initials = `${firstname?.[0] || ''}${lastname?.[0] || ''}`;

  const isGrouped = !!groupId;

  const isPartiallyPaid = depositTransferred > 0 && depositTransferred < cartTotal;

  const isAssignFromPreviousCampaign = !!oldAgencyIfu;

  return {
    id,
    pilgrim,
    firstname,
    lastname,
    birthdate,
    npi,
    nic,
    isNpiValid,
    passport,
    passportExpirationDate,
    isPassportValid,
    isInternational,
    note,
    agencyName,
    nextSteps,
    deposits,
    depositTotal,
    cartTotal,
    depositTransferred,
    health,
    isHealthy,
    doctorName,
    doctorEmail,
    doctorNotes,
    customization,
    customizationName,
    customizationApproved,
    customizationDescription,
    customizationPrice,
    categoryId,
    categoryName,
    isInvoiceFullyPaid,
    isVisaSubmission,
    isApprovedForMAECStep,
    hasCompletedMedicalCheckup,
    isApprovedForMSStep,
    isRejectedForMSStep,
    isElligible,
    selfRegistered,
    status,
    initials,
    isGrouped,
    groupId,
    groupName,
    isPartiallyPaid,
    oldAgencyIfu,
    isAssignFromPreviousCampaign,
    department,
  };
};

export default useGetPilgrim;
